import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=5bbf0f2c&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=5bbf0f2c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf0f2c",
  null
  
)

export default component.exports